import { render, staticRenderFns } from "./PaidStudent.vue?vue&type=template&id=59153ffc&scoped=true&"
import script from "./PaidStudent.vue?vue&type=script&lang=js&"
export * from "./PaidStudent.vue?vue&type=script&lang=js&"
import style0 from "./PaidStudent.vue?vue&type=style&index=0&id=59153ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59153ffc",
  null
  
)

export default component.exports